import { render, staticRenderFns } from "./product-search.vue?vue&type=template&id=06d5aeea&scoped=true"
import script from "./product-search.vue?vue&type=script&lang=js"
export * from "./product-search.vue?vue&type=script&lang=js"
import style0 from "./product-search.vue?vue&type=style&index=0&id=06d5aeea&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/page/product-search.less?vue&type=style&index=1&id=06d5aeea&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5aeea",
  null
  
)

export default component.exports